import ComponentManager from '@/Management/ComponentManager';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import WindowViewModelT from '@/ViewModels/Controls/WindowViewModel';
import { IWindowViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';

export default class WindowViewModelBuilder<T = null> extends ControlViewModelBuilder<WindowViewModelT, T>{

    protected properties: IWindowViewModelConstructorParameter;
    protected headlineBuilder: LabelViewModelBuilder<this>;
    
    public constructor(parent?: T) {
        super(parent);
    }

    public withContent(content: ObservableOrDefault<JQuery>): this {
        this.properties.content = content;
        return this;
    }

    public withHeadline(): LabelViewModelBuilder<this> {
        if (this.headlineBuilder == null)
            this.headlineBuilder = new LabelViewModelBuilder<this>(this);

        return this.headlineBuilder;
    }

    public withHeadlineErgName(ergName: string): this {
        return this.withHeadline().withErgName(ergName).done();
    }

    public withWidth(width: ObservableOrDefault<number | string>): this {
        this.properties.width = width;
        return this;
    }

    public withIsModal(isModal: ObservableOrDefault<boolean>): this {
        this.properties.isModal = isModal;
        return this;
    }

    public withIsOpen(isOpen: ObservableOrDefault<boolean>): this {
        this.properties.isOpen = isOpen;
        return this;
    }

    public withAllowClose(allowClose: ObservableOrDefault<boolean>): this {
        this.properties.allowClose = allowClose;
        return this;
    }

    public withIsMessageBox(isMessageBox: ObservableOrDefault<boolean>): this {
        this.properties.isMessageBox = isMessageBox;
        return this;
    }    

    public updateProperties(properties: Partial<IWindowViewModelConstructorParameter>): this {
        $.extend(this.properties, properties);
        return this;
    }

    /**
     * @override
     */
    protected preBuild(): void {
        if (this.headlineBuilder != null)
            this.properties.headline = this.headlineBuilder.build();
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): WindowViewModelT {
        const WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModelT>('WindowViewModel');

        return new WindowViewModel(this.properties);
    }
}